// Ported from design/project/App70-DepositSuccess.dc.html, then wired to the deposit the indexer just credited.
import { formatUsdt } from "@degenduel/shared";
import { fit } from "../fit.js";
import { useGame } from "../game.js";
import { lastDeposit, walletName } from "../money.js";
import { go } from "../router.js";

function pendingFrom(): { at: number; from: string | null; amount: string | null } | null {
  try {
    return JSON.parse(sessionStorage.getItem("dd:pendingDeposit") ?? "null") as { at: number; from: string | null; amount: string | null } | null;
  } catch {
    return null;
  }
}

export function App70_DepositSuccess() {
  const { me } = useGame();
  const d = lastDeposit;
  const p = pendingFrom();
  if (!d) {
    go("App28", true);
    return null;
  }
  const credited = formatUsdt(BigInt(d.credited));
  const returned = BigInt(d.returned);
  const took = p ? Math.max(1, Math.round((d.at - p.at) / 1000)) : null;

  return (
    <>
      <div className="screen">
  <div className="orbL" aria-hidden="true" style={{ top: "40px", left: "-45px", width: "480px", height: "480px" }}></div>
  <div className="pad squeeze" style={{ height: "100%", paddingBottom: "44px" }}>
    <div className="top"><span className="chip chipL">DEPOSIT CONFIRMED</span></div>
    <div style={{ marginTop: fit(6, 18), alignSelf: "center", width: fit(88, 120), height: fit(88, 120), borderRadius: "50%", background: "#CCFF00", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 0 10px rgba(204,255,0,0.12), 0 0 60px rgba(204,255,0,0.45)" }}>
      <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#0B0E14" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12.5 L10 17.5 L19 7"></path></svg>
    </div>
    <span className="mono lime" style={{ marginTop: fit(14, 26), alignSelf: "center", fontWeight: "800", fontSize: "40px" }}>+{credited}</span>
    <h1 className="h1" style={{ marginTop: "6px", textAlign: "center" }}>Deposit landed</h1>
    <p className="muted" style={{ margin: "8px 6px 0", textAlign: "center", fontSize: "14px", lineHeight: "21px" }}>Your battle balance is now <b className="mono" style={{ color: "#FFFFFF" }}>{me?.balance.available ?? "..."} USDT</b>. Every battle from here is gas free.</p>
    <div className="g" style={{ marginTop: fit(12, 20), borderRadius: "20px", padding: "4px 0" }}>
      <div className="li"><span className="muted" style={{ flex: "1", fontSize: "13px" }}>From</span><span style={{ fontSize: "13px" }}>{p?.amount ? walletName(p.from) : "Sent to the vault address"}</span></div>
      <div className="div" style={{ margin: "0 14px" }}></div>
      <div className="li"><span className="muted" style={{ flex: "1", fontSize: "13px" }}>Network fee</span><span style={{ fontSize: "13px" }}>{p?.amount ? "Paid by your wallet" : "Paid by the sender"}</span></div>
      {took !== null && took < 600 && <>
        <div className="div" style={{ margin: "0 14px" }}></div>
        <div className="li"><span className="muted" style={{ flex: "1", fontSize: "13px" }}>Took</span><span style={{ fontSize: "13px" }}><span className="mono">{took} seconds</span></span></div>
      </>}
      {returned > 0n && <>
        <div className="div" style={{ margin: "0 14px" }}></div>
        <div className="li"><span className="muted" style={{ flex: "1", fontSize: "13px" }}>Over the 10,000 limit</span><span style={{ fontSize: "13px" }}><span className="mono">{formatUsdt(returned)}</span> goes back</span></div>
      </>}
    </div>
    <div style={{ marginTop: "auto", paddingTop: "12px", display: "flex", flexDirection: "column", gap: "10px" }}>
      <button onClick={() => go("App09", true)} className="btnP" style={{ border: "0", cursor: "pointer" }}>START BATTLING</button>
      <button onClick={() => go("App28", true)} className="btnS" style={{ cursor: "pointer" }}>View wallet</button>
    </div>
  </div>
</div>
    </>
  );
}
